export class Device {

  constructor(
    public model: string = '',
    public serial: string = '',
    public allocatedTo: string = '',
    public currentAllocation: any = '',
    public allocationCounter: number = 0,
    public creationDate: any = '',
    public key: string = '') {}
}



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/shared/classes/device.ts